import { compR } from "../func/compr";
import { iterator } from "../iterator";
import { ensureReduced, reduced } from "../reduced";
export function take(n, src) {
  return src ? iterator(take(n), src) : function (rfn) {
    var r = rfn[2];
    var m = n;
    return compR(rfn, function (acc, x) {
      return --m > 0 ? r(acc, x) : m === 0 ? ensureReduced(r(acc, x)) : reduced(acc);
    });
  };
}